import AccordionItem from 'components/v2/common/AccordionItem';
import DataSourceDetails from './DataSourceDetails';
import DataSourceSummary from './DataSourceSummary';

export default function DataSource({handle, trendsHandle, isTrendsOnly, label, organizationId, organizationTrendsId}) {
    return (
        <AccordionItem
                summaryComponent={
                    <DataSourceSummary
                        handle={handle}
                        trendsHandle={trendsHandle}
                        isTrendsOnly={isTrendsOnly}
                        label={label}
                    />
                }>
            <DataSourceDetails
                handle={handle}
                trendsHandle={trendsHandle}
                isTrendsOnly={isTrendsOnly}
                label={label}
                organizationId={organizationId}
                organizationTrendsId={organizationTrendsId}
            />
        </AccordionItem>
    );
}
